import { useScheduleTimezoneSync } from "@/lib/api/mentor-schedule";
import { useCurrentUser, UserRole } from "@/lib/api/user";

export function useTimezoneDetection() {
  const { data: user } = useCurrentUser();
  useScheduleTimezoneSync(user?.role === UserRole.MENTOR);
}
